import { render, staticRenderFns } from "./VirtualList.vue?vue&type=template&id=5779fca2&scoped=true"
import script from "./VirtualList.vue?vue&type=script&lang=js"
export * from "./VirtualList.vue?vue&type=script&lang=js"
import style0 from "./VirtualList.vue?vue&type=style&index=0&id=5779fca2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779fca2",
  null
  
)

export default component.exports